<div class="signin-container mt-5">
  <form
    #loginForm="ngForm"
    class="form-signin"
    (ngSubmit)="loginForm.form.valid && login(loginForm)"
    novalidate
  >
    <h1 class="h3 mb-3 font-weight-normal">Please sign in</h1>
    <div
      class="mb-3"
      [ngClass]="{ 'has-error': loginForm.submitted && !username.valid }"
    >
      <label for="inputUsername" class="form-label">Email address</label>
      <input
        type="text"
        id="inputUsername"
        name="username"
        class="form-control"
        placeholder="Email address"
        autofocus
        ngModel
        required
        #username="ngModel"
      />
      <div *ngIf="loginForm.submitted && !username.valid" class="help-block">
        Your email address is required
      </div>
    </div>
    <div
      class="mb-3"
      [ngClass]="{ 'has-error': loginForm.submitted && !password.valid }"
    >
      <label for="inputPassword" class="form-label">Password</label>
      <input
        type="password"
        id="inputPassword"
        name="password"
        class="form-control"
        placeholder="Password"
        ngModel
        required
        #password="ngModel"
      />
      <div *ngIf="loginForm.submitted && !password.valid" class="help-block">
        Password is required
      </div>
    </div>
    <div class="mb-3">
      <button class="btn btn-lg btn-primary btn-block" type="submit">
        Login
      </button>
    </div>
    <div>
      <api-error [apiError]="apiError"></api-error>
    </div>
    <div *ngIf="settings.tenantName.includes('Eurogeographics')">
      <a routerLink="/forgotten-password">Forgotten password?</a>
    </div>
    <div *ngIf="settings.tenantName.includes('Eurogeographics')">
      <a routerLink="/register">Register for an account</a>
    </div>
  </form>
</div>
